<template>
    <a :href="link || null"
       class="sidebar-block"
       :target="link ? isExternal ? '_blank' : '_self' : null">
        <div class="sidebar-block__content">
            <div class="sidebar-block__action-title">
                {{ title }}
            </div>
            <div class="sidebar-block__description">
                {{ description }}
            </div>
            <STBaseButton :text="button"
                          icon-after="IconRightFill"
                          icon-after-modify="icon-fill icon_color_blue"
                          modify="button_theme_reset" />
        </div>
    </a>
</template>

<script>
export default {
    name: 'SidebarLink',

    props: {
        title      : String,
        description: String,
        button     : String,
        link       : String,
        isExternal : Boolean,
    },

    methods: {
        openPopup() {
            this.$emit('openPopup');
        }
    }
};
</script>

<style lang="scss">
@import "../Default/SidebarBlock";
</style>
